import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import * as api from '../../../api/educentialApi';
import TestPrepDashboard from './TestPrepDashboard';
import MyTests from './MyTests';
import TestCatalog from './TestCatalog';
import PracticeTests from './PracticeTests';

const TestPrepServiceRoutes = () => {
  const [enrolled, setEnrolled] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    checkEnrollment();
  }, []);

  const checkEnrollment = async () => {
    try {
      const status = await api.getServiceStatus('test-prep');
      setEnrolled(status.enrolled);
      
      if (!status.enrolled) {
        await api.enrollInService('test-prep');
        setEnrolled(true);
      }
    } catch (err) {
      console.error('Enrollment check failed:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <Routes>
      <Route index element={<TestPrepDashboard />} />
      <Route path="my-tests" element={<MyTests />} />
      <Route path="catalog" element={<TestCatalog />} />
      <Route path="practice" element={<PracticeTests />} />
    </Routes>
  );
};

export default TestPrepServiceRoutes;
